import axiosInstance from '@/plugins/axios'
// 查询国家列表
export const getCountryList = ({ optionAll = false } = {}) => {
  return axiosInstance.get('/visa/admin/country', {
    params: {
      page: 1,
      limit: 10000
    },
  }).then(res => {
    const list = res.data.map(item => {
      return {
        value: item.countryId,
        label: item.countryName
      }
    })
    if (optionAll) {
      list.unshift({
        label: '全部',
        value: 0,
      })
    }
    return list
  })
}
export const getWikiCategoryList = () => {
  return axiosInstance
    .post('/operation-web-api/admin/wikiCategory/queryList', {
      data: {},
      fetchAll: true,
    })
    .then(res => {
      return res.data.content.map(item => {
        return {
          value: item.categoryId,
          label: item.name,
          origin: item,
        }
      })
    })
}
export const getAreaList = countryId => {
  return axiosInstance
    .get('/visa/admin/consular/region', {
      params: {
        countryId,
      },
    })
    .then(res => {
      return res.data.map(item => {
        return {
          value: item.consularRegionId,
          label: item.consularRegionName,
        }
      })
    })
}
export const getRegionList = (id) => {
  let parentId = 0
  if (id) {
    parentId = id
  }
  return axiosInstance
    .get('/additional/admin/region/getListByParentId?parentId=' + parentId)
    .then(res => {
      return res.data.map(item => {
        return {
          value: item.id,
          label: item.shortname,
          origin: item,
        }
      })
    })
}
// 1 旅行社  2 供应商
export const getCompanyList = ({ companyType = '', companyName = '' } = {}) => {
  return axiosInstance
    .get('/company/admin/company/queryCompanyNameByCompanyList', {
      params: {
        companyName,
        companyType,
      },
    })
    .then(res => {
      return res.data.map(item => {
        return {
          value: item.companyId,
          label: item.companyName,
          origin: item,
        }
      })
    })
}
